import { createContext, useContext } from "react";

interface IBusinessTicketContext {
  department: any;
}

const BusinessTicketContext = createContext<IBusinessTicketContext>({
  department: null,
});

export const BusinessTicketContextProvider = BusinessTicketContext.Provider;
export const useBusinessTicketContext = () => useContext(BusinessTicketContext);
